import React, { Component } from 'react'
import {connect} from 'react-redux'
import moment from 'moment'

import { money } from '../Utils/Service'

import { deleteReceipts } from '../../actions/Receipts'

import Modal from '../Modal'

class DeleteReceipt extends Component {
  deleteReceipts () {
    this.props.deleteReceipts({ id: this.props.receipt.id })
  }
  render () {
    const { ajaxStatus } = this.props.receipts
    const r = this.props.receipt
    return (
      <Modal>
        <h3>Eliminare ricevuta</h3>
        <button
          className="lnk-close-modal"
          onClick={() => this.props.hideModal()}
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </button>
        <ul className="delete-list">
          <li>
            <span>Numero</span>
            {r.number}
          </li>
          <li>
            <span>Data</span>
            {moment.unix(r.emission_date).format('ll')}
          </li>
          <li>
            <span>Importo</span>
            {money(r.amount)}
          </li>
          <li>
            <span>Intestatario</span>
            {r.account_holder_name_surname}
          </li>
        </ul>
        <ul className="submit-btn">
          <li>
            <span className="ajax-error">{ajaxStatus}</span>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.props.hideModal()}
            >
              annulla
            </button>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.deleteReceipts()}
            >
              elimna
            </button>
          </li>
        </ul>
      </Modal>
    )
  }
}

function mapStateToProps (state) {
  return state
}

export default connect(mapStateToProps, { deleteReceipts })(DeleteReceipt)



// WEBPACK FOOTER //
// ./src/components/Receipts/DeleteReceipt.js